import * as React from 'react'

export default function GTMScript({ gtmId }: { gtmId: string }) {
  return (
    <script
      type="text/javascript"
      id="googleTagManager"
      data-cookieconsent="ignore"
      // eslint-disable-next-line react/no-danger -- in this case we need this prop
      dangerouslySetInnerHTML={{
        __html:
          // language=JavaScript
          `
              function googleTagManagerLoad(w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
              var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
              j.async = true;
              j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
              j.addEventListener("load", function () {
              var _ge = document.createEvent("CustomEvent");
              _ge.initCustomEvent("gtm_loaded", true, false, null);
              d.dispatchEvent(_ge);
            });
              f.parentNode.insertBefore(j, f);
            }

              window.addEventListener(
              "load",
              function load() {
              removeEventListener("load", load, false);
              googleTagManagerLoad(
              window,
              document,
              "script",
              "dataLayer",
              "${gtmId}"
              );
            },
              false
              );
            `,
      }}
    />
  )
}
